import React, { Component } from 'react';
import ReactMd from 'react-md-file';

class Home extends Component {
  render() {
    return (
      <ReactMd fileName="/home.md" />
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js